import * as React from 'react';

import imagePlaceholder from '@app/images/image-placeholder.png';
import {getImagePath} from '@app/objects/Image';

const PetMemorialGallerySlide = ({index, item}) => {
	const [imgSrc, setImgSrc] = React.useState(item);

	React.useEffect(() => {
		setImgSrc(item);
	}, []);
	const avatarHeight = 700;
	const avatarWidth = 400;
	return (
		<div className="pet-mem-modal__content-gallery-slider-item">
			<img
				src={imgSrc !== imagePlaceholder ? getImagePath(imgSrc, avatarHeight, avatarWidth) : imgSrc}
				alt="pet-image"
				onError={() => setImgSrc(imagePlaceholder)}
			/>
		</div>
	);
};

export default PetMemorialGallerySlide;